var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.3 160.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n      .cls-2 {\n        fill: #fff;\n\n      }\n      .cls-3 {\n        stroke-linecap: round;\n        \n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30.74,108.16c.09-1.74.26-3.48.27-5.23.02-19.16-.03-38.33.04-57.49.02-5.67,3.5-9.78,8.61-10.65,4.58-.78,9.45,2.18,10.85,6.88.51,1.71.52,3.61.53,5.42.05,9.93.02,19.86.02,30.03,10.37-5.42,14.14-4.23,19.31,5.72,8.63-5.79,14.86-3.93,18.29,5.77,1.25-.76,2.4-1.56,3.64-2.2,6.55-3.41,14.45.68,14.67,8.06.32,10.82.6,21.7-.18,32.48-1.04,14.42-12.84,26.81-27.22,28.47-8.7,1.01-17.63.78-26.39.2-9.74-.64-17.73-5.51-24-12.91-8.4-9.91-16.65-19.96-24.89-30.01-4.43-5.4-4.34-11.14.03-15.13,4.3-3.93,10.24-3.5,15.07,1.52,3.19,3.32,5.92,7.09,8.86,10.66.83-.53,1.67-1.06,2.5-1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.04,
    y: 151.5,
    width: 63,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m28.25,52.03c-5.28-3.81-8.71-10.02-8.71-17.03,0-11.6,9.4-21,21-21s21,9.4,21,21c0,6.58-3.03,12.45-7.76,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m26.37,65.92c-11.7-5.37-19.83-17.2-19.83-30.92C6.54,16.22,21.76,1,40.54,1s34,15.22,34,34c0,13.38-7.73,24.95-18.96,30.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerPointer);
export default __webpack_public_path__ + "static/media/finger-pointer.bb8ceb6bcaf14cc9c3df6a969f5015da.svg";
export { ForwardRef as ReactComponent };